import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[avanoComboboxTemplate]',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {}
})
export class AvanoComboboxTemplateDirective {
  @Input() type: string;

  @Input('avanoComboboxTemplate') name: string;

  constructor(public template: TemplateRef<any>) {}

  getType(): string {
    return this.name;
  }
}

export interface ComboboxEntry {
  label: string;
  value: any;
}
